import sliderPerson from '../../../../../../src24/js/modules/sliderPerson';

window.addEventListener('load', () => {
    sliderPerson.init();
});
